import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import ProjectsView from "@/views/ProjectsView.vue";
import AboutView from "@/views/AboutView.vue";
import TechnologiesView from "@/views/TechnologiesView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/projects",
    name: "Projects",
    component: ProjectsView,
  },
  {
    path: "/",
    name: "About me",
    component: AboutView,
  },
  {
    path: "/tech",
    name: "Technologies",
    component: TechnologiesView,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
